/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import * as Yup from 'yup';

export const validationSchema = Yup.object({
  name: Yup.string().trim().max(50, 'max_length').required('empty'),
  description: Yup.string().trim().nullable().max(200, 'max_length'),
});
